import * as React from 'react';
import {
    View,
    StyleSheet,
    Button,
    Text,
    Image,
    ScrollView
} from 'react-native';

import useStatusBar from '../hooks/useStatusBar';
import {getLearn} from '../components/Firebase/firebase';
import logo from '../assets/logo.png';

import {AcademicCapIcon, FilmIcon, GlobeAltIcon as GlobeIcon} from "react-native-heroicons/solid";
import {StatusBar} from 'expo-status-bar';
import {LogoutIcon, InformationCircleIcon} from "react-native-heroicons/outline";

import {Video, AVPlaybackStatus} from 'expo-av';
import AppButton from '../components/AppButton';
import AppMiniButton from '../components/AppMiniButton';
export default function LearnScreen({navigation, route}) {
    useStatusBar('dark-content');
    const video = React.useRef(null);
    const [status, setStatus] = React.useState({});
    const [data, setData] = React.useState([]);

    React.useEffect(() => {
        let getData = async () => {
            let data_import = await getLearn().get()
            let tempBlogs = [];
            data_import
                .docs
                .forEach(item => {
                    tempBlogs.push({data: item.data(), id: item.id});
                })
            setData(tempBlogs)
        }

        getData();
    }, []);

    return (
        <ScrollView contentContainerStyle={styles.container}>
            <Text
                style={{
                    fontSize: 50,
                    color: 'white',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    marginBottom: 30
                }}>Aprender</Text>
            {
                data.map(function (x) {
                    return (
                        <View key={x.id} style={styles.card}>
                            <Image
                                key={x.id + '_image'}
                                source={{
                                    uri: x.data.image
                                }}
                                resizeMode={'cover'}
                                style={{
                                    width: '100%',
                                    height: 200,
                                    borderRadius: 24
                                }}/>
                            <Text
                                style={{
                                    fontSize: 40,
                                    color: 'white',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    marginVertical: 15
                                }}>{x.data.title}</Text>
                            <AppMiniButton
                                onPress={() => navigation.navigate('Reproductor', {video_url: route.params.video_url})}
                                title="Empezar"></AppMiniButton>
                            <AppMiniButton
                                onPress={() => navigation.navigate('LearnPage', {
                                    author: x.data.author,
                                    author_img: x.data.author_img,
                                    descripcion: x.data.descripcion,
                                    image_url: x.data.image,
                                    id: x.id,
                                    title: x.data.title,
                                    video_url: x.data.video_url
                                })}
                                color="secondary"
                                title="Leer más"></AppMiniButton>
                        </View>
                    );
                })
            }
        </ScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        paddingBottom: 40,
        paddingHorizontal: 15,
        minHeight: '100%',
        paddingTop: 35,
        backgroundColor: '#111827'
    },
    card: {
        backgroundColor: "rgba(31,41,55, 1)",
        borderRadius: 24,
        marginTop: 10,
        width: '100%',
        marginBottom: 10,
        padding: 20,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 12
        },
        shadowOpacity: 0.58,
        shadowRadius: 16.00,
        elevation: 24
    },
    buttonText: {
        fontSize: 36,
        fontWeight: 'bold',
        textTransform: 'uppercase'
    },
    video: {
        alignSelf: 'center',
        width: 320,
        height: 200
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    rowe: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignContent: 'flex-start'
    },
    col3: {
        flex: 1
    },
    col9: {
        flex: 2
    }
});
